/**
 * @generated SignedSource<<558daa336f37a45cf8c51db66687182a>>
 * @relayHash cd23865b41513285c6d6d49de5a843b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54d0eb14ee09e2860c98ebaef917e7c6703b62f43981ac06a31c0422bceda6c5

import type { ConcreteRequest } from 'relay-runtime';
export type ContentUnifiedQuery$variables = {
  contentId: string;
  isSSR?: boolean | null | undefined;
  preloadLabels?: boolean | null | undefined;
  spaceKey?: string | null | undefined;
  useNewContentTopper?: boolean | null | undefined;
  versionOverride?: number | null | undefined;
};
export type ContentUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly body: {
        readonly dynamic: {
          readonly content: {
            readonly id: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly representation: string | null | undefined;
          readonly value: string | null | undefined;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null | undefined;
                readonly js: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly tags: {
              readonly css: string | null | undefined;
              readonly js: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly labels?: {
        readonly count: number | null | undefined;
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly label: string | null | undefined;
          readonly name: string | null | undefined;
          readonly prefix: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly macroRenderedOutput?: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: {
          readonly representation: string | null | undefined;
          readonly value: string | null | undefined;
          readonly webresource: {
            readonly tags: {
              readonly css: string | null | undefined;
              readonly js: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth?: string | null | undefined;
          readonly fabricEditorSupported: boolean | null | undefined;
        } | null | undefined;
        readonly lastModifiedDate: string | null | undefined;
      };
      readonly operations?: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly space: {
        readonly alias: string | null | undefined;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
      readonly status: string | null | undefined;
      readonly subType: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
      readonly version: {
        readonly confRev: string | null | undefined;
        readonly number: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null | undefined;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null | undefined;
          readonly backgroundAttachment: string | null | undefined;
          readonly backgroundBlendMode: string | null | undefined;
          readonly backgroundClip: string | null | undefined;
          readonly backgroundColor: string | null | undefined;
          readonly backgroundImage: string | null | undefined;
          readonly backgroundOrigin: string | null | undefined;
          readonly backgroundPosition: string | null | undefined;
          readonly backgroundRepeat: string | null | undefined;
          readonly backgroundSize: string | null | undefined;
          readonly borderRadius: string | null | undefined;
          readonly padding: string | null | undefined;
        } | null | undefined;
        readonly screen: {
          readonly background: string | null | undefined;
          readonly backgroundAttachment: string | null | undefined;
          readonly backgroundBlendMode: string | null | undefined;
          readonly backgroundClip: string | null | undefined;
          readonly backgroundColor: string | null | undefined;
          readonly backgroundImage: string | null | undefined;
          readonly backgroundOrigin: string | null | undefined;
          readonly backgroundPosition: string | null | undefined;
          readonly backgroundRepeat: string | null | undefined;
          readonly backgroundSize: string | null | undefined;
          readonly gutterBottom: string | null | undefined;
          readonly gutterLeft: string | null | undefined;
          readonly gutterRight: string | null | undefined;
          readonly gutterTop: string | null | undefined;
          readonly layer: {
            readonly background: string | null | undefined;
            readonly backgroundAttachment: string | null | undefined;
            readonly backgroundBlendMode: string | null | undefined;
            readonly backgroundClip: string | null | undefined;
            readonly backgroundColor: string | null | undefined;
            readonly backgroundImage: string | null | undefined;
            readonly backgroundOrigin: string | null | undefined;
            readonly backgroundPosition: string | null | undefined;
            readonly backgroundRepeat: string | null | undefined;
            readonly backgroundSize: string | null | undefined;
            readonly height: string | null | undefined;
            readonly width: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null | undefined;
    } | null | undefined;
    readonly theme: {
      readonly name: string | null | undefined;
      readonly themeKey: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ContentUnifiedQuery = {
  response: ContentUnifiedQuery$data;
  variables: ContentUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "number"
},
v9 = {
  "kind": "ScalarField",
  "name": "value"
},
v10 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v8/*: any*/)
  ]
},
v11 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ]
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "representation"
},
v13 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "background"
},
v17 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v18 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v19 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v20 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v21 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v22 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v23 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v24 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v25 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v26 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "versionOverride"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "subType"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "alias"
              }
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "confRev"
              },
              (v8/*: any*/)
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "cover-picture-id-published",
                  "emoji-title-published",
                  "editor",
                  "import-source",
                  "imported-page-modified-date"
                ]
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
          },
          {
            "condition": "useNewContentTopper",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "pageTitlePublished",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "page-title-property-published"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": "properties(key:\"page-title-property-published\")"
              }
            ]
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
              },
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fabricEditorSupported"
                  },
                  {
                    "condition": "useNewContentTopper",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "coverPictureWidth"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isSSR",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "MapOfStringToFormattedBody",
                "kind": "LinkedField",
                "name": "macroRenderedOutput",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "concreteType": "FormattedBody",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v12/*: any*/),
                      {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": (v14/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v9/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "WebResourceDependencies",
                    "kind": "LinkedField",
                    "name": "webresource",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "SuperBatchWebResources",
                        "kind": "LinkedField",
                        "name": "superbatch",
                        "plural": false,
                        "selections": (v14/*: any*/)
                      },
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "appearancePublished",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": "properties(key:\"content-appearance-published\")"
          },
          {
            "condition": "preloadLabels",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "ASCENDING",
                      "sortField": "LABELLING_CREATIONDATE"
                    }
                  }
                ],
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "count"
                  },
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "label"
                      },
                      (v15/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "prefix"
                      }
                    ]
                  }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              },
              {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "operation"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetType"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "concreteType": "Theme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "kind": "ScalarField",
            "name": "themeKey"
          }
        ]
      },
      {
        "concreteType": "LookAndFeel",
        "kind": "LinkedField",
        "name": "lookAndFeel",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentLookAndFeel",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "concreteType": "ScreenLookAndFeel",
                "kind": "LinkedField",
                "name": "screen",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "concreteType": "LayerScreenLookAndFeel",
                    "kind": "LinkedField",
                    "name": "layer",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "width"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "height"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "gutterTop"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "gutterRight"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "gutterBottom"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "gutterLeft"
                  }
                ]
              },
              {
                "concreteType": "ContainerLookAndFeel",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "padding"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "borderRadius"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "routeOverrideEnabled"
          }
        ]
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAnonymouslyAuthorized"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedQuery",
    "selections": (v26/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedQuery",
    "selections": (v26/*: any*/)
  },
  "params": {
    "cacheID": "cd23865b41513285c6d6d49de5a843b3",
    "id": "54d0eb14ee09e2860c98ebaef917e7c6703b62f43981ac06a31c0422bceda6c5",
    "metadata": {},
    "name": "ContentUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false)@allowHigherTimeout{content(id:$contentId,version:$versionOverride){nodes{id,status,type,subType,title,space{id,key,alias},version{confRev,number},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},metadata{lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},body{dynamic{representation,value,content{version{number},id},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}}\n      operations@include(if:$preloadLabels){operation,targetType}}},space(key:$spaceKey){id,theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}"
  }
};
})();

(node as any).hash = "eba1a55eeff9fde81bf5185d674eb51b";

export default node;
